<template>
  <b-modal id="deleteModal" centered
  modal-class="modal-irish-date">
    <div class="d-block mb-4">
      <!-- <b-form-input :id="event_id" :event_id="event_id" v-model="event_id" type="number"></b-form-input> -->
      <input id="user_id" name="user_id" type="hidden" v-model="user_id" />
      <p class="confirmMessageModalP message-modal-mid my-4">Are you sure to delete this user?</p>
    </div>
    <template class="justify-content-center mt-5" #modal-footer>
      <b-row class="justify-content-center w-100">
        <b-col lg="4" md="6" class="text-center">
          <b-button type="button"
            variant="mid-danger"
            class="btn-bumblebee btn-mid btn-mid-submit w-100"
            
            @click="clickConfirmDelete"
             v-if="!is_loading"
          >
            Yes
          </b-button>
            <b-button
            type="button"
            disabled
            variant="mid-primary"
            class="btn-bumblebee btn-mid btn-mid-submit w-100"
            v-else
          >
            <b-spinner small label="Small Spinner" variant="light"></b-spinner>
            Loading
          </b-button>
        </b-col>

        <b-col lg="4" md="6" class="text-center">
          <b-button
            type="button"
            variant="mid-secondary-outline"
            class="btn-bumblebee btn-mid btn-mid-submit w-100"
            @click="closeModalDelete"
          >
            Cancel
          </b-button>
        </b-col>
      </b-row>
    </template>
  </b-modal>
</template>

<script>
import $ from "jquery";
import axios from "axios";

export default {
  name: "DeleteUser",
  props: ["user_id"],
  data() {
    return {
      is_loading : false
    };
  },
  mounted() {
    // console.log(this.$parent)
  },
  methods: {
    clickConfirmDelete() {
      // this.$bvModal.hide("deleteModal");
      // let formData = new FormData();
      // formData.append("user_id", $("#deleteModal #user_id").val());

      // axios
      //   .post("delete_user", formData, {
      //     headers: {
      //       "Content-Type": "multipart/form-data",
      //       Authorization: "Bearer pDwS5OF6",
      //     },
      //   })
      //   .then((response) => {
      //     console.log(response);
      //     this.$bvModal.hide("deleteModal");
      //     this.$fire({
      //       // title: "Title",
      //       text: response.data.message,
      //       type: "success",
      //       timer: 5000,
      //     }).then((r) => {
      //       // console.log(r.value);
      //     });
      //   });
      this.is_loading = true
      axios
        .delete("admin/users/" + $("#deleteModal #user_id").val(), {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: "MID",
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          // console.log(response);
          this.is_loading = false
          this.$fire({
            // title: "Title",
            text: response.data.success,
            type: "success",
            // timer: 5000,
          }).then((r) => {
            // console.log(r.value);
            // console.log(r);
            // console.log(r.value);
          });
          // console.log("test")
          this.$bvModal.hide("deleteModal");
          // console.log("test2")
          // this.$parent.$router.go();
          // console.log(this.$parent)
          this.$parent.getUserList()
          // console.log("test3")
        })
        .catch((error) => {
          // console.log(error.response.data.error);
          // console.log(error.request);
          // console.log(error.message);
          this.is_loading = false

          this.$fire({
            // title: "Title",
            text: error.response.data.error,
            type: "error",
            // timer: 5000,
          }).then((r) => {
            // console.log(r);
            // console.log(r.value);
          });
          // this.$parent.getUserList()
          // this.loginErrorMessage = error.response.data.error;
          // this.showLoginErrorMessage = true;
        });
    },
    closeModalDelete() {
      this.$bvModal.hide("deleteModal");
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/my_irish_date/users/DeleteUser.vue